var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styles } from './styles';
import { cn } from "../../../helpers";
export function createGridNormalRowRenderer(_a) {
    var isRowInactive = (_a === void 0 ? {} : _a).isRowInactive;
    return function renderGridRow(_a) {
        var className = _a.className, originalRenderer = _a.originalRenderer, rest = __rest(_a, ["className", "originalRenderer"]);
        if (!originalRenderer) {
            throw new Error('GridCore error: "originalRenderer" must be provided ');
        }
        var inactive = isRowInactive === null || isRowInactive === void 0 ? void 0 : isRowInactive(rest.index);
        return originalRenderer(__assign(__assign({}, rest), { inactive: inactive, className: cn(className, styles.root, rest.disabled && styles.disabled, inactive && styles.inactive) }));
    };
}
//# sourceMappingURL=createGridNormalRowRenderer.js.map